itsoftApp.createModule("formsValidation", ["pageLoad"], function() {
    const module = this;
    const BYTES_IN_MB = 1048576

    const FormChecker = function (validationElement) {
        this.RECAPTCHA_KEY_2 = "6LdkUxclAAAAACYE06P_y3boBH1kzKV8CDfIxQmZ";
        this.RECAPTCHA_KEY = "6Lf0UhclAAAAAPHCqH0h_PJI3ihybr7ERcJFFTLX";
        this.validationElement = validationElement;
        this.captchaFlag = false;
        this.form = validationElement.querySelector(".js-form-validate");
        this.formCaptcha = this.form.classList.contains("js-captcha");
        this.formCaptchaEls = document.querySelectorAll(".js-captcha-el");
        this.formCaptchaBadgeTextEls = document.querySelectorAll(".js-captcha-badge-text");
        this.formCaptchaText = document.querySelectorAll(".js-captcha-text");
        this.formId = this.form.id;
        this.resultId = this.form.getAttribute("data-result");
        this.formErrorMsg = this.form.querySelector(".form__error-msg");
        this.formServerMsgBlock = this.form.querySelector(".js-server-block");
        this.formServerMsg = this.form.querySelector(".js-server-msg");
        this.formSuccessMsg = this.form.querySelector(".js-success-msg");
        this.formInvalidMsg = this.form.querySelector(".form__invalid-msg");
        this.formTimeout = this.form.querySelector(".js-timeout");

        this.passInput = this.form.querySelector("[data-pass]");
        this.passInputRepeat = this.form.querySelector("[data-pass-repeat]");
        this.allInputs = this.form.querySelectorAll(".form__input, .form__textarea");
        this.allFormFlags = this.form.querySelectorAll(".form__checkbox");
        this.inputEventFlag = false;
        this.submitFlag = false;
        this.inputsChecked = false;
        this.validationPassed = true;
        this.inputsDate = this.form.querySelectorAll("input[data-date]");
        this.inputsEmail = this.form.querySelectorAll("input[data-email]");
        this.inputsTel = this.form.querySelectorAll("[data-mask]");
        this.inputsNumber = this.form.querySelectorAll("[data-number]");
        this.inputsInitials = this.form.querySelectorAll("[data-initials]");
        this.inputsText = this.form.querySelectorAll("[data-text]");
        this.inputsFile = this.form.querySelectorAll("[type='file']");
        this.fileResetButton = this.form.querySelector(".js-file-reset");
        this.fileZone = this.form.querySelector(".js-file-zone");
        this.fileInstance = null;
        this.currentInputFile = this.inputsFile.length > 0 && this.inputsFile[0];
        this.dataRelationElement = this.form.querySelector("[data-relation]");
        this.submitButton = this.form.querySelector("[type='submit']");

        this.selectEls = this.form.querySelectorAll(".js-select");

        this.relationELementsInput = this.form.querySelectorAll("input[data-relation]:not([type='radio'])");
        this.relationELementsRadio = this.form.querySelectorAll("input[type='radio'][data-relation]");
        this.inputToken = this.form.querySelector(".form__token");
        this.inputToken2 = this.form.querySelector(".form__token-2");
        this.inputAction = this.form.querySelector(".form__action");
        this.widgetCaptcha = false;

        this.popupSuccessId = this.form.getAttribute("data-success-result-id");
        this.popupErrorId = this.form.getAttribute("data-error-result-id");
        this.popupSuccessResult = "";
        this.popupErrorResult = "";
        this.inputsFilled = this.form.querySelectorAll(".form__input--filled");
        this.openedPopups = document.querySelectorAll(".popup.is-opened");
        this.parseResponse = "";
        this.status = false;
        this.resetPrevent = this.form.hasAttribute("data-prevent-reset");
        this.parentPopup = this.form.closest(".popup");

        this.libraries = {
            captcha: {
                name: "captcha",
                queue: [],
                started: false,
                loaded: false,
                script: "https://www.google.com/recaptcha/api.js?render=explicit&onload=onRecaptchaLoadCallback"
            },

            mask: {
                name: "inputMask",
                queue: [],
                started: false,
                loaded: false,
                script: "/assets/scripts/inputmask/inputmask.min.js"
            },

            datepicker: {
                name: "datepicker",
                queue: [],
                started: false,
                loaded: false,
                style: "/assets/scripts/flatpickr/flatpickr.min.css",
                script: "/assets/scripts/flatpickr/flatpickr.min.js",
                scriptMore: "/assets/scripts/flatpickr/ru.min.js"
            }
        }

        this.init();
    }

    FormChecker.prototype.resetFile = function () {
        const fileWrapper = this.currentInputFile.closest(".form__file-wrapper");
        let formFilename;

        if (fileWrapper) {
            formFilename = fileWrapper.querySelector(".form__file-name");
        }

        if (this.fileZone) {
            this.fileZone.classList.remove("js-active");
        }

        this.fileInstance = null;
        this.currentInputFile.value = "";
        formFilename.textContent = "";
    }

    FormChecker.prototype.handleFile = function () {
        const fileWrapper = this.currentInputFile.closest(".form__file-wrapper");
        let formFilename;

        if (fileWrapper) {
            formFilename = fileWrapper.querySelector(".form__file-name");
        }

        if (this.fileInstance) {
            formFilename.textContent = this.fileInstance.name;

            if (this.fileZone) {
                this.fileZone.classList.add("js-active");
            }
        } else {
            this.resetFile();
        }
    }

    FormChecker.prototype.addFile = function (file) {
        this.fileInstance = file;
        this.handleFile();
    }

    FormChecker.prototype.onInputFileChange = function (evt) {
        this.currentInputFile = evt.currentTarget;

        const files = this.currentInputFile.files;

        if (files.length > 0 && files[0].size > 3 * BYTES_IN_MB) {
            this.resetFile();
            alert('Принимается файл до 3 МБ')
            return false
        } else {
            this.fileInstance = files[0];
            this.handleFile();
        }
    }

    FormChecker.prototype.checkInputsDate = function () {
        const FORM_CHECKER = this;

        Array.prototype.forEach.call(this.inputsDate, function (inputDate) {
            const inputWrapper = inputDate.closest(".form__input-wrapper");

            const options = {
                locale: "ru",
                disableMobile: true,
                dateFormat: "d.m.Y",
                allowInput: true,
                static: true,
                appendTo: inputWrapper,
                nextArrow: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 16.7962L8 7.20377C8 6.34461 9.01192 5.88543 9.6585 6.45119L15.1399 11.2474C15.5952 11.6458 15.5952 12.3542 15.1399 12.7526L9.65851 17.5488C9.01192 18.1146 8 17.6554 8 16.7962Z" fill="#393C63"/>
                </svg>`,
                prevArrow: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 16.7962L16 7.20377C16 6.34461 14.9881 5.88543 14.3415 6.45119L8.86009 11.2474C8.40476 11.6458 8.40476 12.3542 8.86009 12.7526L14.3415 17.5488C14.9881 18.1146 16 17.6554 16 16.7962Z" fill="#393C63"/>
                </svg>`,
                onChange: function (selectedDates, dateStr, instance) {
                    inputDate.setAttribute("data-complete", true);
                    inputDate.classList.remove("js-error");
                    inputDate.classList.add("js-passed");
                    inputWrapper.classList.remove("js-error-wrapper");
                    inputWrapper.classList.remove("js-passed-wrapper");
                },
            }

            const datePicker = flatpickr(inputDate, options);

            /* Чтобы сработала HTML-валидация поля */
            inputDate.addEventListener("focus", function (evt) {
                inputDate.blur();
                inputDate.readonly = false;
            });
        });
    }

    FormChecker.prototype.checkInputsTel = function () {
        const FORM_CHECKER = this;

        Array.prototype.forEach.call(FORM_CHECKER.inputsTel, function (inputTel) {
            Inputmask('+7(999)999-99-99', {
                showMaskOnHover: false,
                oncomplete: function () {
                    inputTel.setAttribute("data-complete", true);
                },
                onincomplete: function () {
                    inputTel.removeAttribute("data-complete");
                }
            }).mask(inputTel);
        });
    }

    FormChecker.prototype.sendRequest = function (data, onHandler) {
        const FORM_CHECKER = this;
        const xhr = new XMLHttpRequest();
        const URL = this.form.getAttribute("action");

        xhr.addEventListener("load", function () {
            onHandler(xhr.response);
        });

        xhr.addEventListener('error', function () {
            // console.log('ERROR')
            if (FORM_CHECKER.formServerMsgBlock) {
                FORM_CHECKER.formServerMsgBlock.classList.add("is-active");
                FORM_CHECKER.formServerMsg.textContent = "Произошла ошибка соединения";
                FORM_CHECKER.form.classList.remove("js-submit-process");
            }
        });
    
        xhr.addEventListener('timeout', function () {
            // console.log('TIMEOUT')

            if (FORM_CHECKER.formServerMsgBlock) {
                // console.log('TIMEOUT CHECKER')
                FORM_CHECKER.formServerMsgBlock.classList.add("is-active");
                FORM_CHECKER.formServerMsg.textContent = 'Запрос не успел выполниться за ' + xhr.timeout + ' мс';
                FORM_CHECKER.form.classList.remove("js-submit-process");
            }
        });
    
        xhr.timeout = 10000;

        xhr.open("POST", URL);
        // xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.send(data);
    }

    FormChecker.prototype.init = function () {
        const FORM_CHECKER = this;

        const startSetup = function () {
            const pregnancyOptions = FORM_CHECKER.form.querySelectorAll(".js-pregnant-input");
            const pregnancyYesOption = FORM_CHECKER.form.querySelector("#patient-pregnancy-yes");

            const sexOptions = FORM_CHECKER.form.querySelectorAll(".js-sex-input");
            const sexFemaleOption = FORM_CHECKER.form.querySelector("#patient-sex-f");

            const hiddenPregnancyField = FORM_CHECKER.form.querySelector(".js-pregnancy");
            const hiddenGestationalAgeField = FORM_CHECKER.form.querySelector(".js-gestational-age");

            const toggleSex = function () {
                if (sexFemaleOption.checked) {
                    hiddenPregnancyField.classList.remove("js-hidden");

                    if (pregnancyYesOption.checked) {
                        hiddenGestationalAgeField.classList.remove("js-hidden");
                    } else {
                        hiddenGestationalAgeField.classList.add("js-hidden");
                    }
                } else {
                    hiddenPregnancyField.classList.add("js-hidden");
                    hiddenGestationalAgeField.classList.add("js-hidden");
                }
            }

            const togglePregnancy = function () {
                if (pregnancyYesOption.checked) {
                    hiddenGestationalAgeField.classList.remove("js-hidden");
                } else {
                    hiddenGestationalAgeField.classList.add("js-hidden");
                }
            }

            if (pregnancyOptions.length > 0) {
                Array.prototype.forEach.call(pregnancyOptions, function (option) {
                    option.addEventListener("change", function () {
                        togglePregnancy();
                    });
                });
            }

            if (sexOptions.length > 0) {
                Array.prototype.forEach.call(sexOptions, function (option) {
                    option.addEventListener("change", function () {
                        toggleSex();
                    });
                });
            }

            if (FORM_CHECKER.fileResetButton) {
                FORM_CHECKER.fileResetButton.addEventListener("click", function (evt) {
                    evt.preventDefault();
                    FORM_CHECKER.resetFile();
                });
            }

            if (FORM_CHECKER.inputsNumber.length > 0) {
                Array.prototype.forEach.call(FORM_CHECKER.inputsNumber, function (inputNumber) {
                    inputNumber.addEventListener("keydown", function (evt) {
                        if ((evt.keyCode < 48 || evt.keyCode > 57) && (evt.keyCode < 37 || evt.keyCode > 40) && evt.keyCode !== 8 && evt.keyCode !== 46 && evt.keyCode !== 48 && evt.keyCode !== 57 && evt.keyCode !== 109 && evt.keyCode !== 107 && (evt.keyCode < 96 || evt.keyCode > 105)) {
                            evt.preventDefault();
                        }
                    });
                });
            }

            if (FORM_CHECKER.inputsInitials.length > 0) {
                Array.prototype.forEach.call(FORM_CHECKER.inputsInitials, function (inputInitial) {
                    inputInitial.addEventListener('keydown', function(event) {
                        const key = event.key;
            
                        if (/[а-яА-ЯЁё]/.test(key)) {
                            if (inputInitial.value.length >= 3) {
                                event.preventDefault();
                            }
                        } else {
                            if (key !== "Backspace" && key !== "Delete" && key !== "ArrowLeft" && key !== "ArrowRight") {
                                event.preventDefault();
                            }
                        }
                    });
                });
            }
    
            if (FORM_CHECKER.inputsText.length > 0) {
                Array.prototype.forEach.call(FORM_CHECKER.inputsText, function (input) {
                    input.addEventListener("keydown", function (evt) {
                        if (!(/[-a-zA-Zа-яА-ЯЁё\s]+/i.test(evt.key))) {
                            evt.preventDefault();
                        }
                    });
                });
            }
    
            if (FORM_CHECKER.inputsTel.length > 0) {
                new itsoftApp.modules.startLoad.callback(FORM_CHECKER.checkInputsTel.bind(FORM_CHECKER), FORM_CHECKER.libraries.mask);
            }

            if (FORM_CHECKER.inputsDate.length > 0) {
                new itsoftApp.modules.startLoad.callback(FORM_CHECKER.checkInputsDate.bind(FORM_CHECKER), FORM_CHECKER.libraries.datepicker);
            }

            if (FORM_CHECKER.inputsFile.length > 0) {
                Array.prototype.forEach.call(FORM_CHECKER.inputsFile, function (inputFile) {
                    inputFile.addEventListener("change", FORM_CHECKER.onInputFileChange.bind(FORM_CHECKER));
                    itsoftApp.modules.dragNDropFile.init(FORM_CHECKER.form, FORM_CHECKER.addFile.bind(FORM_CHECKER));
                });
            }
    
            if (FORM_CHECKER.dataRelationElement) {
                Array.prototype.forEach.call(FORM_CHECKER.relationELementsRadio, function (el) {
                    el.addEventListener("change", function (evt) {
                        const switchEl = evt.currentTarget;
    
                        if (switchEl.checked) {
                            const relationGroup = switchEl.getAttribute("data-relation-group");
                            const relationGroupElements = FORM_CHECKER.form.querySelectorAll("[data-relation-group='" + relationGroup + "']:not([type='radio'])");
                            const relationName = switchEl.getAttribute("data-relation");
                            const inputs = FORM_CHECKER.form.querySelectorAll("input[data-relation='" + relationName + "']:not([type='radio'])");
    
                            Array.prototype.forEach.call(relationGroupElements, function (groupEl) {
                                groupEl.required = false;
                            });
    
                            Array.prototype.forEach.call(inputs, function (input) {
                                input.required = true;
                            });
                        }
                    });
                });
            }
    
            if (FORM_CHECKER.popupSuccessId && FORM_CHECKER.popupErrorId) {
                FORM_CHECKER.popupSuccessResult = document.querySelector(FORM_CHECKER.popupSuccessId);
                FORM_CHECKER.popupErrorResult = document.querySelector(FORM_CHECKER.popupErrorId)
            } else {
                FORM_CHECKER.popupSuccessResult = document.querySelector("#popup-success-result");
                FORM_CHECKER.popupErrorResult = document.querySelector("#popup-error-result");
            }

            FORM_CHECKER.validatePassedFields();
            FORM_CHECKER.validateForm();

            FORM_CHECKER.form.onsubmit = function (evt) {
                evt.preventDefault();
                FORM_CHECKER.onFormSubmit.call(FORM_CHECKER);
            }
        }

        if (this.formCaptcha) {
            this.captchaFlag = true;
            window.onRecaptchaLoadCallback = function () {
              Array.prototype.forEach.call(FORM_CHECKER.formCaptchaEls, function (formCaptchaEl) {
                window.clientId = {};
                window.clientId.formId = grecaptcha.render(formCaptchaEl, {
                    "sitekey": FORM_CHECKER.RECAPTCHA_KEY,
                    "size": "invisible",
                    "badge": "inline"
                });
              });

              Array.prototype.forEach.call(FORM_CHECKER.formCaptchaBadgeTextEls, function (formBadgeText) {
                formBadgeText.innerHTML = '<p><small>Этот сайт защищен reCAPTCHA<br> <a href="https://policies.google.com/privacy" target="_blank" rel="nofollow noopener">Политика конфиденциальности</a> Google и <a href="https://policies.google.com/terms" target="_blank" rel="nofollow noopener">Условия использования</a>.</small></p>';
              });
            }
        }

        if (this.formCaptcha) {
            new itsoftApp.modules.startLoad.callback(startSetup, this.libraries.captcha);
        } else {
            startSetup();
        }
    }

    FormChecker.prototype.addError = function (input) {
        const errorMessage = input.getAttribute("data-error-message");
        const inputWrapper = input.closest(".form__input-wrapper");
        let errorContainer;

        if (inputWrapper) {
            errorContainer = inputWrapper.querySelector(".form__error-text");
        }

        if (errorContainer) {
            errorContainer.classList.add("is-active");
        }

        if (errorContainer && errorMessage) {
            errorContainer.textContent = errorMessage;
        }
        

        input.classList.add("js-error");
        input.parentNode.classList.add("js-error-wrapper");

        input.classList.remove("js-passed");
        input.parentNode.classList.remove("js-passed-wrapper");
        
        if (this.formInvalidMsg && !this.formInvalidMsg.classList.contains("is-active")) {
            this.formInvalidMsg.classList.add("is-active")
        }

        if (input.parentNode.classList.contains("js-success-wrapper")) {
            input.parentNode.classList.remove("js-success-wrapper");
        }
    }

    FormChecker.prototype.removeError = function (input, success) {
        const inputWrapper = input.closest(".form__input-wrapper");
        let errorContainer;

        if (inputWrapper) {
            errorContainer = inputWrapper.querySelector(".form__error-text");
        }

        if (errorContainer) {
            errorContainer.classList.remove("is-active");
            errorContainer.textContent = "";
        }

        input.classList.remove("js-error");
        input.classList.add("js-passed")
        input.parentNode.classList.remove("js-error-wrapper");
        input.parentNode.classList.add("js-passed-wrapper");

        if (success) {
            input.parentNode.classList.add("js-success-wrapper"); //TODO: проверить
        }
    }

    FormChecker.prototype.passValidation = function () {
        if (this.passInput.value !== this.passInputRepeat.value) {
            this.addError(passInputRepeat);
            this.validationPassed = false;
        } else {
            if (this.passInputRepeat.classList.contains("js-error")) {
                this.removeError(this.passInputRepeat);
            }
        }
    }

    FormChecker.prototype.telValidation = function (inputTel) {
        if (inputTel.hasAttribute("required") && !inputTel.hasAttribute("data-complete")) {
            this.addError(inputTel);
            this.validationPassed = false;
        } else if (inputTel.hasAttribute("required") && inputTel.hasAttribute("data-complete")) {
            this.removeError(inputTel);
        }
    }

    FormChecker.prototype.emailValidation = function (inputEmail) {
        if (inputEmail.hasAttribute("required") && inputEmail.hasAttribute("data-pattern")) {
            const defaultPattern = /^(?=.{1,256})(?!.*\.@)(?!.*\.\.)(?!.*@\.)(?!.*\.$)(?!.*\.{2})([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

            if (!defaultPattern.test(inputEmail.value)) {
                this.addError(inputEmail);
                this.validationPassed = false;
            } else {
                this.removeError(inputEmail);
            }
        } else {
            this.removeError(inputEmail);
        }
    }

    FormChecker.prototype.dateValidation = function (inputDate) {
        const FORM_CHECKER = this;

        setTimeout(function () {
            if (inputDate.hasAttribute("required") && !inputDate.hasAttribute("data-complete")) {
                // FORM_CHECKER.addError(inputDate);
                FORM_CHECKER.validationPassed = false;
            } else if (inputDate.hasAttribute("required") && inputDate.hasAttribute("data-complete")) {
                // FORM_CHECKER.removeError(inputDate);
            }
        }, 500)
    }

    FormChecker.prototype.selectValidation = function (select) {
        if (!(select.classList.contains("is-selected"))) {
          this.addError(select);
          this.validationPassed = false;
        } else {
          this.removeError(select);
        }
    }

    FormChecker.prototype.checkAdditionally = function () {
        const FORM_CHECKER = this;

        if (!this.form.classList.contains("js-validation-active")) {
            this.form.classList.add("js-validation-active");
        }

        this.validationPassed = true;

        if (this.selectEls.length > 0) {
            Array.prototype.forEach.call(this.selectEls, function (selectEl) {
                if (selectEl.hasAttribute("data-required")) {
                    FORM_CHECKER.selectValidation(selectEl);
                }
            });
        }

        if (this.passInput && this.passInputRepeat) {
            this.passValidation(this.passInput, this.passInputRepeat);
        }

        if (this.inputsEmail.length > 0) {
            Array.prototype.forEach.call(this.inputsEmail, function (inputEmail) {
                FORM_CHECKER.emailValidation(inputEmail);
            });
        }

        if (this.inputsTel.length > 0) {
            Array.prototype.forEach.call(this.inputsTel, function (inputTel) {
                FORM_CHECKER.telValidation(inputTel);
            });
        }

        if (this.inputsDate.length > 0) {
            Array.prototype.forEach.call(this.inputsDate, function (inputDate) {
                if (inputDate.hasAttribute("data-required")) {
                    FORM_CHECKER.dateValidation(inputDate);
                }
            });
        }
    }

    FormChecker.prototype.onFormSubmit = function (evt) {
        const FORM_CHECKER = this;

        if (!this.inputsChecked) {
            this.checkAdditionally();
        }

        this.inputsChecked = false; // возвращаем значение по дефолту, чтобы при следующей проверке также выполнялась checkAdditionally

        if (!this.validationPassed) {
            this.formInvalidMsg.classList.add("is-active");
            return;
        } else {
            this.formInvalidMsg.classList.remove("is-active");
        }

        if (!this.submitFlag) {
            this.submitFlag = true;
            this.form.classList.add("js-submit-process");

            if (!this.formCaptcha) {
                DEBUG && console.log("отправляем форму без капчи, sendForm, not-captcha")
                this.sendRequest(new FormData(this.form), this.onHandler.bind(FORM_CHECKER));
            } 
            else {
                DEBUG && console.log("собираемся отправить форму с капче, sendForm, with captcha loading")

                if (typeof grecaptcha != 'undefined' && typeof clientId.formId != 'undefined') {
                    grecaptcha.ready(function () {
                        grecaptcha.execute(clientId.formId, {action: FORM_CHECKER.form.getAttribute("data-name")}).then(function (token) {
                            const gResponseEls = document.querySelectorAll(".g-recaptcha-response");
                            Array.prototype.forEach.call(gResponseEls, function (el) {
                                el.name = el.id;
                            });
                            FORM_CHECKER.inputToken.setAttribute("value", token);
                            FORM_CHECKER.inputAction.setAttribute("value", FORM_CHECKER.form.getAttribute("name"));
                            FORM_CHECKER.sendRequest(new FormData(FORM_CHECKER.form), FORM_CHECKER.onHandler.bind(FORM_CHECKER));
                            DEBUG && console.log("отправили форму с капчей, sendForm, with captcha sended")
                        });
                    });
                }
            }
        }
    }

    FormChecker.prototype.checkInput = function (input) {
        this.addError(input);

        input.setCustomValidity("");
    }

    FormChecker.prototype.onFieldInput = function (evt) {
        // if (evt.target.checkValidity()) { // note: эта строчка нужна, если валидация полей происходит только при отправке формы, то есть когда this.attemptToSubmitForm имеет значение true

            // if (evt.target.classList.contains("js-error") || !this.attemptToSubmitForm || (this.attemptToSubmitForm && !evt.target.checkValidity())) {
                if (evt.target.checkValidity() && !evt.target.hasAttribute("data-validation") && evt.target.required) {
                    this.removeError(evt.target, true);
                } else if (evt.target.required) {
                    this.addError(evt.target);
                }

                if (evt.target.hasAttribute("data-email")) {
                    this.emailValidation(evt.target);
                }

                if (evt.target.hasAttribute("data-date")) {
                    this.dateValidation(evt.target);
                }

                if (evt.target.hasAttribute("data-mask")) {
                    this.telValidation(evt.target);
                }

                if (evt.target.hasAttribute("data-pass-repeat")) {
                    this.passValidation();
                }
            // }
        // };
    }

    FormChecker.prototype.onInputInvalid = function (evt) {
        const FORM_CHECKER = this;

        if (!this.form.classList.contains("js-validation-active")) {
            this.form.classList.add("js-validation-active");
        }

        if (!this.inputsChecked) {
            this.checkAdditionally();
        }

        this.checkInput(evt.target);
    }

    FormChecker.prototype.validatePassedFields = function () {
        const FORM_CHECKER = this;

        this.inputEventFlag = true;

        if (this.allInputs.length > 0) {
            Array.prototype.forEach.call(this.allInputs, function (input) {
                input.addEventListener("input", FORM_CHECKER.onFieldInput.bind(FORM_CHECKER));
            });
        }

        if (this.allFormFlags.length > 0) {
            Array.prototype.forEach.call(this.allFormFlags, function (flag) {
                flag.addEventListener("change", FORM_CHECKER.onFieldInput.bind(FORM_CHECKER));
            });
        }
    }

    FormChecker.prototype.validateForm = function () {
        const FORM_CHECKER = this;

        if (this.allInputs.length > 0) {
            Array.prototype.forEach.call(this.allInputs, function (input) {
                input.addEventListener("invalid", FORM_CHECKER.onInputInvalid.bind(FORM_CHECKER));
            });
        }

        if (this.allFormFlags.length > 0) {
            Array.prototype.forEach.call(this.allFormFlags, function (flag) {
                flag.addEventListener("invalid", FORM_CHECKER.onInputInvalid.bind(FORM_CHECKER));
            });
        }
    }

    FormChecker.prototype.onErrorLoad = function (data) {
        if (this.popupErrorResult) {
            this.popupResultError.dispatchEvent(openEvent);
        }

        this.submitFlag = false;
    }

    FormChecker.prototype.resetForm = function () {
        this.inputsFilled = this.form.querySelectorAll(".form__input--filled");
        
        this.form.reset();

        Array.prototype.forEach.call(this.inputsFilled, function (input) {
            input.classList.remove("form__input--filled");
            input.parentNode.classList.remove("js-success-wrapper");
        });
    }

    FormChecker.prototype.isJsonString = function (str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    FormChecker.prototype.setTokenV2 = function (token) {
        DEBUG && console.log('setotken2')
        DEBUG && console.log(FORM_CHECKER.inputToken2, ' FORM_CHECKER.inputToken2')
        DEBUG && console.log(token, ' token')
        FORM_CHECKER.inputToken2.setAttribute("value", token);
    }

    FormChecker.prototype.onHandler = function (response) {
        const FORM_CHECKER = this;
        this.openedPopups = document.querySelectorAll(".popup.is-opened");
        this.parseResponse;
        this.status = true;

        if (this.isJsonString(response)) {
            this.parseResponse = JSON.parse(response);
        }

        if (this.parseResponse) {
            this.status = this.parseResponse.status;
        }

        if (this.status === 200 || this.status === true || this.status === "true") {
            if (!this.resetPrevent) {
                this.resetForm();

                if (this.formServerMsgBlock) {
                    this.formServerMsgBlock.classList.remove("is-active");
                }
                
                if (this.formServerMsgBlock) {
                    this.formServerMsgBlock.classList.remove("is-active");
                }

                DEBUG && console.log("очищаем форму, resetForm")
            }

            if (this.parentPopup && this.parentPopup.hasAttribute("data-hide") && this.form.hasAttribute("data-hide")) {
                this.parentPopup.dispatchEvent(closeEvent);
            }

            if (this.popupSuccessResult) {
                this.popupSuccessResult.dispatchEvent(openEvent);
            }

            this.form.classList.remove("js-submit-process");

            if (this.allInputs.length > 0) {
                Array.prototype.forEach.call(this.allInputs, function (input) {
                    const inputWrapper = input.closest(".form__input-wrapper");
                    input.classList.remove("js-passed");
                    inputWrapper.classList.remove("js-passed-wrapper");
                    input.removeAttribute("data-complete");
                });
            }

            if (this.inputsDate.length > 0) {
                Array.prototype.forEach.call(this.inputsDate, function (inputDate) {
                    const inputWrapper = inputDate.closest(".form__input-wrapper");
                    inputDate.classList.remove("js-passed");
                    inputWrapper.classList.remove("js-passed-wrapper");
                    inputDate.removeAttribute("data-complete");
                });
            }

            if (this.selectEls.length > 0) {
                Array.prototype.forEach.call(itsoftApp.modules.select.selects[this.form.getAttribute("name")], function (choice) {
                    choice.removeActiveItems();
                    // choice.setChoiceByValue("");
                });

                Array.prototype.forEach.call(this.selectEls, function (selectWrapper, index) {
                    const placeholderEl = selectWrapper.querySelector(".choices__list--dropdown");
                    const placeholder = placeholderEl.getAttribute("data-placeholder");

                    const mainInput = selectWrapper.querySelector(".choices__list--single");
                    const choicesItem = mainInput.querySelector(".choices__item");
                    
                    selectWrapper.classList.remove("js-passed");
                    selectWrapper.classList.remove("is-selected");
                    
                    if (!choicesItem) {
                        var divEl = document.createElement("div");
                        divEl.className = "choices__item form__select-placeholder choices__item--selectable";

                        if (placeholder) {
                            divEl.textContent = placeholder;
                        }
                    }

                    if (!choicesItem) {
                        mainInput.appendChild(divEl);
                    }
                });
            }

            FORM_CHECKER.form.classList.remove("js-validation-active");

            this.submitFlag = false;

        } else {
            if (FORM_CHECKER.widgetCaptcha) {
                this.form.classList.remove("js-submit-process");
                grecaptcha.reset(FORM_CHECKER.widgetCaptcha);
            } else {
                FORM_CHECKER.widgetCaptcha = grecaptcha.render('captcha', {
                    'sitekey': FORM_CHECKER.RECAPTCHA_KEY_2,
                    'callback': FORM_CHECKER.setTokenV2
                })
                this.form.classList.remove("js-submit-process");
            }

            if (this.formErrorMsg) {
                this.formErrorMsg.classList.add("is-active");
            }

            if (this.popupErrorResult) {
                const messageContainer = this.popupErrorResult.querySelector(".js-server-error");
                if (messageContainer && this.parseResponse.hasOwnProperty("message")) {
                    messageContainer.innerHTML = this.parseResponse.message;
                }
                this.popupErrorResult.dispatchEvent(openEvent);
            }

            this.submitFlag = false;
        }
    }

    module.callback = FormChecker;
});
